import gql from 'graphql-tag';

import { useUiQueries } from '../../lib/hooks';
import fetcher from './uiDataFetcher';

const QUERY = gql`
	query uiData_curricula {
		uiData {
			curricula {
				id
				name
				subname
				gradeRangeName
				color
				iconUrl
				intentUrl
				url
			}
		}
	}
`;

const transformer = (d) => [
	...d.uiData.curricula,
	{
		id: 'my_assignments',
		name: 'My Assignments',
		subname: '',
		iconURL: 'https://f2b-cms.s3.amazonaws.com/prod/my_assignments_size_250_3b1b168708.png',
		color: '#A0A0A0',
	}, {
		id: '',
		name: 'Other',
		subname: '',
		iconURL: 'https://f2b-cms.s3.amazonaws.com/prod/unknown_curriculum_id_c15f00521e.svg',
		color: '#000000',
	},
].map(e => ({...e, accessible: true}));

const useCurricula = (nodes) => useUiQueries(
	[{
		document: QUERY,
		options: {
			queryKey: ['uiData_curricula'],
			transformer: transformer,
		},
	}],
	fetcher,
)[0];
export default useCurricula;
